'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const BreadcrumbLink = forwardRef(({ asChild, className, ...props }, ref) => {
    const Comp = asChild ? Slot : 'a';
    return (_jsx(Comp, { ref: ref, className: cn('flex items-center gap-2 text-metal-400 transition-colors hover:text-metal-900 dark:text-metal-300 dark:hover:text-white', className), ...props }));
});
BreadcrumbLink.displayName = 'BreadcrumbLink';
export { BreadcrumbLink };
